import { useState } from 'react';
import { Modal } from '../../Components/Modal/Modal';
import { Button } from '../../Components/Button/Button';
import { ExerciseLog } from '../../Clients/reminds';
import { useExerciseTypesContext } from '../../Contexts/ExerciseTypes.Context';
import styles from './AddExerciseLogModal.module.css';

interface AddExerciseLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (exerciseLog: ExerciseLog) => void;
}

export const AddExerciseLogModal: React.FC<AddExerciseLogModalProps> = ({ isOpen, onClose, onAdd }) => {
  const { data: exerciseTypes = [] } = useExerciseTypesContext();
  const [formData, setFormData] = useState<Partial<ExerciseLog>>({
    exerciseTypeId: undefined,
    numberOfReps: 0,
    numberOfSets: 0,
    comment: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.exerciseTypeId && formData.numberOfReps && formData.numberOfSets) {
      // User will be auto-added on the backend
      onAdd(formData as ExerciseLog);
      setFormData({ exerciseTypeId: undefined, numberOfReps: 0, numberOfSets: 0, comment: '' });
      onClose();
    }
  };

  const handleCancel = () => {
    setFormData({ exerciseTypeId: undefined, numberOfReps: 0, numberOfSets: 0, comment: '' });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel}>
      <h2 className={styles.title}>Add Exercise</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.field}>
          <label htmlFor="exerciseType" className={styles.label}>
            Exercise Type *
          </label>
          <select
            id="exerciseType"
            className={styles.select}
            value={formData.exerciseTypeId || ''}
            onChange={e => setFormData({ ...formData, exerciseTypeId: parseInt(e.target.value) })}
            required
          >
            <option value="">Select exercise type</option>
            {exerciseTypes.map(type => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.field}>
          <label htmlFor="reps" className={styles.label}>
            Number of Reps *
          </label>
          <input
            id="reps"
            type="number"
            className={styles.input}
            value={formData.numberOfReps || 0}
            onChange={e => setFormData({ ...formData, numberOfReps: parseInt(e.target.value) || 0 })}
            min="1"
            required
          />
        </div>

        <div className={styles.field}>
          <label htmlFor="sets" className={styles.label}>
            Number of Sets *
          </label>
          <input
            id="sets"
            type="number"
            className={styles.input}
            value={formData.numberOfSets || 0}
            onChange={e => setFormData({ ...formData, numberOfSets: parseInt(e.target.value) || 0 })}
            min="1"
            required
          />
        </div>

        <div className={styles.field}>
          <label htmlFor="comment" className={styles.label}>
            Comment (optional)
          </label>
          <textarea
            id="comment"
            className={styles.textarea}
            value={formData.comment || ''}
            onChange={e => setFormData({ ...formData, comment: e.target.value })}
            placeholder="Additional notes..."
            rows={3}
          />
        </div>

        <div className={styles.actions}>
          <Button type="button" onClick={handleCancel} style={{ backgroundColor: 'var(--color-surface-primary)' }}>
            Cancel
          </Button>
          <Button type="submit">Add</Button>
        </div>
      </form>
    </Modal>
  );
};
